import { Icon, IconProps, Popover, Text } from '@oneaudi/unified-web-components';
import { TextVariant } from 'node_modules/@oneaudi/unified-web-components/dist/esm/components/text';
import { ReactNode, useState } from 'react';
import { TooltipLabelStyles } from '~/components/tooltip-label/styles/tooltip-label-style';
import { cn } from '~/utils/merge-classnames';

interface Props {
	label: string;
	tooltip: string | ReactNode;
	variant?: TextVariant;
	tooltipSize?: IconProps['size'];
	popoverAnchor?: string;
}

export const TooltipLabel = ({ label, tooltip, variant, tooltipSize, popoverAnchor }: Props) => {
	const [open, setOpen] = useState(false);
	return (
		<TooltipLabelStyles>
			<Text className={cn('tooltip-label')} variant={variant}>
				{label}
				<Popover
					id={'incentives-popover-title'}
					open={open}
					alignment="left"
					triggerElement={
						<div style={{ cursor: 'pointer' }} onClick={() => setOpen(true)}>
							<Icon name={'info-circle'} className="info-btn" size={'xs'} />
						</div>
					}
					content={
						typeof tooltip === 'string' ? (
							<Text variant={{ type: 'copy', order: '2', style: 'normal' }}>{tooltip}</Text>
						) : (
							tooltip
						)
					}
					onClose={() => setOpen(false)}
					withTip={false}
				/>
			</Text>
		</TooltipLabelStyles>
	);
};
